import React from 'react';
import styled from 'styled-components';

import Labels from './Labels';
import Section from '../../common/Section';
import Anchor from '../utils/Anchor';

const Wrapper = styled(Section)`
  padding: 3rem var(--default-horizontal-padding);
  padding-top: 0;
`;

export default () => {
  return (
    <React.Fragment>
      <Anchor id="labels-section" />
      <Wrapper>
        <Labels />
      </Wrapper>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/labels/LabelsSection.js